import { Component, ElementRef, ViewChild } from '@angular/core';
import { CommonService } from '../../service/common.service';
import { LoggedInUserKeys, LoggedInUserService } from '../../service/logged-in-user.service';
import { AppUsersDto } from '../../model/app-users-dto';
import { HttpStatusCode } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ShowpopupDirective } from '../../directives/showpopup.directive';
import { Subscription } from 'rxjs';
import { ChangePasswordFormComponent } from '../popup-forms/change-password-form/change-password-form.component';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { HrService } from 'src/app/hr/hr.service';
import { AdminService } from 'src/app/admin/admin.service';
import { Perm, PermissionService } from '../../service/permission.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    standalone: false
})
export class HeaderComponent {
  loginUser: AppUsersDto;
  readonly P = Perm;
  @ViewChild(ShowpopupDirective, { static: false })
  loadPopup!: ShowpopupDirective;
  resetPasswordForm: FormGroup;
  private closeSubscription!: Subscription;
  confirmpassword: string;
  @ViewChild('dropdownElement') dropdownElement: ElementRef;
  constructor(public readonly _commonServices: CommonService,
    private readonly _loggedInUserService: LoggedInUserService, private readonly _toaster: ToastrService, private readonly _router: Router, private readonly fb: FormBuilder, private readonly hrService: HrService,
    private readonly _adminService: AdminService, public readonly _permissionServices: PermissionService) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.loginUser = this._loggedInUserService.getLoggedInUser(LoggedInUserKeys.LOGGED_IN_USER);
    }, 100);
    this.resetFormCreate();
  }

  logOut() {
    this._commonServices.logoutUser().subscribe((response) => {
      if (response.statusCode === HttpStatusCode.Ok) {
        this._toaster.success(response.message, 'info');
        this._loggedInUserService.clearEntireStorage();
        if(this.loginUser.userRole == 'FRACTAL_ADMIN'){
          this._router.navigate([this._commonServices.Navigations.USER_SIGN_IN])
        } else if (this.loginUser.userRole == 'FRACTAL_HR' || this.loginUser.userRole =='CLIENT_HR'){
          this._router.navigate([this._commonServices.Navigations.USER_SIGN_IN])
        } else if (this.loginUser.userRole == 'COLLEGE_ADMIN'){
          this._router.navigate([this._commonServices.Navigations.COLLEGE_ADMIN_SIGNIN])
        }
        else{
          this._router.navigate([this._commonServices.Navigations.SIGN_IN]);
        }

      }
    })
  }

  isOpen = false;
  togglePopup() {
    this.isOpen = !this.isOpen;
  }
  closeDropdown() {
    this.isOpen = false;
  }

  getUsernameInitials(name: any) {
    const matches = name?.match(/\b(\w)/g);
    return matches?.join('');
  }

  resetFormCreate() {
    this.resetPasswordForm = this.fb.group(
      {
        email: [''],
        oldPassword: ['', [Validators.required]],
        newPassword: ['', [Validators.required, this.passwordValidator]],
        confirmPassword: [
          '',
          Validators.required,
        ],
      },
      { validators: this.passwordMatchingValidatior }

    );
  }
  passwordMatchingValidatior: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    const password = control.get("newPassword");
    const confirmPassword = control.get("confirmPassword");
    return password?.value === confirmPassword?.value
      ? null
      : { notmatched: true };
  }
  openChangePasswordPopup() {
    const hostViewContainerRef = this.loadPopup.viewPopup;

    hostViewContainerRef.clear();

    const componentRef = hostViewContainerRef.createComponent(ChangePasswordFormComponent);

    this.closeSubscription = componentRef.instance.close.subscribe(() => {
      this.closeSubscription.unsubscribe();
      hostViewContainerRef.clear();
    });
    this.closeSubscription = componentRef.instance.confirmPasswordCheck.subscribe(
      (el) => {
        this.confirmpassword = el;
      }

    );
    componentRef.instance.resetPasswordForm = this.resetPasswordForm
    if (this.loginUser) {
      componentRef.instance.getLoginEmail = this.loginUser.email;
    }
  }

  passwordValidator(control: AbstractControl): ValidationErrors | null {
    const passwordPattern =
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[!@#$%^&*()_+])[\w!@#$%^&*()_+]{8,}$/;
    if (!passwordPattern.test(control.value)) {
      return { invalidPassword: true };
    }
    return null;
  }

  // downloadMergedVideo() {
  //   this.hrService.downloadMergedVideo().subscribe((response) => {
  //     if(response && response.statusCode === HttpStatusCode.Ok){
  //       let fileType: any =
  //           'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  //         let link = document.createElement('a');
  //         link.href = `data:${fileType};base64,${response.data}`;
  //         link.download = 'merged_video_details';
  //         link.click();
  //     }
  //   })
  // }
  navToReportedQuestion() {
    this._router.navigate([this._commonServices.Navigations.REPORTED_QUESTION]);
  }

  navToServerHealthCheck() {
    this._router.navigate([this._commonServices.Navigations.SERVER_HEALTH_CHECK]);
  }

  routeToWorkdayFailures(){
   this._router.navigate([this._commonServices.Navigations.WORKDAY_FAILURES]);
  }

  canSeeProctoringServer(): boolean {
    return this._adminService.isProctoringServerAllowed();
  }

  navToProctoringServer() {
    this._router.navigate([this._commonServices.Navigations.PROCTORING_SERVER]);
  }
}
